export default "__VITE_ASSET__CP3wsg52__"